<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      :label="$t('analysisRequests.contenance.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      data-cy="cyArTreatment"
      @input="updateData"
    />
    <VTextField
      v-model="data.otherTreatment"
      outlined
      :label="$t('analysisRequests.contenance.otherTreatment')"
      :rules="{ max: 1000 }"
      @input="updateData"
    />
    <VSelect
      v-model="data.evaluation"
      :label="$t('analysisRequests.contenance.evaluation')"
      :items="evaluationTypes"
      :validateAtInitialization="isEdition"
      :required="true"
      outlined
      itemValue="key"
      data-cy="cyArEvaluation"
      @change="updateData"
    />
    <VDatePicker
      v-model="data.tracerAddedDate"
      outlined
      :label="$t('analysisRequests.contenance.tracerAddedDate')"
      :rules="{ required: false }"
      @change="updateData"
    />
    <VDatePicker
      v-model="data.collectionLossDate"
      outlined
      :label="$t('analysisRequests.contenance.collectionLossDate')"
      :rules="{ required: false }"
      @change="updateData"
    />
    <VSelect
      v-model="data.addedTracer"
      :label="$t('analysisRequests.contenance.addedTracer')"
      :validateAtInitialization="isEdition"
      :items="addedTracer"
      itemValue="key"
      outlined
      data-cy="cyArAddedTracer"
      @change="updateData"
    />
    <VTextField
      v-model="data.addedLithium"
      :rules="{ required: true, decimal: 2 }"
      :label="$t('analysisRequests.contenance.addedLithium')"
      outlined
      suffix="kg"
      data-cy="cyArAddedLithium"
      @input="updateData"
    />
    <VTextField
      v-show="false"
      v-model="data.quantityAdded"
      :label="$t('analysisRequests.contenance.quantityAdded')"
      :rules="{ required: false, decimal: 2 }"
      outlined
      suffix="g"
      data-cy="cyArQuantityAdded"
      @input="updateData"
    />
    <VTextField
      v-model="data.estimatedVolume"
      outlined
      :label="$t('analysisRequests.contenance.estimatedVolume')"
      suffix="l"
      :rules="{ decimal: 2 }"
      @input="updateData"
    />
    <VTextField
      v-if="data.addedTracer === 'other'"
      v-model="data.tracerComment"
      outlined
      :label="$t('forms.labels.note')"
      @input="updateData"
    />
  </div>
</template>

<script>
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters } from 'vuex';
import evaluationTypes from '@/constants/evaluationTypes';
import addedTracer from '@/constants/addedTracer';

export default {
    components: {
        VDatePicker,
        VSelect,
        VTextField,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                tracerAddedDate: this.$options.filters.formatDate(this.analysisRequest.tracerAddedDate),
                collectionLossDate: this.$options.filters.formatDate(this.analysisRequest.collectionLossDate),
                quantityAdded: this.analysisRequest.quantityAdded,
                treatment: this.analysisRequest.treatment,
                otherTreatment: this.analysisRequest.otherTreatment,
                estimatedVolume: this.analysisRequest.estimatedVolume,
                addedLithium: this.analysisRequest.addedLithium,
                addedTracer: this.analysisRequest.addedTracer,
                evaluation: this.analysisRequest.evaluation,
                tracerComment: this.analysisRequest.tracerComment,
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
        evaluationTypes() {
            return evaluationTypes.map(type => ({
                name: this.$t(`evaluationTypes.${type}`),
                key: type,
            }));
        },
        addedTracer() {
            return addedTracer.map(type => ({
                name: this.$t(`addedTracer.${type}`),
                key: type,
            }));
        },
    },
    methods: {
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        updateData() {
            this.$emit('updateData', this.data);
        },
    },
};
</script>
